import { Component, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AppComponent } from 'app/app.component';

@Component({
    selector: 'partner-settings-partnership-terms',
    templateUrl: './partner-settings-partnership-terms.component.html',
    styleUrls: ['./partner-settings-partnership-terms.component.scss',
        '../../../../../styles/style-layout.scss']
})

export class PartnerSettingsPartnershipTermsComponent {
    @Input()
    public menuPermissionActive!: string;

    constructor(private messageService: MessageService, public app: AppComponent) { }

    @Input()
    public merchantInfo: any;
}
